<template>
  <div class="cbreadcrumb">
    <span v-for="(item, index) in visibleItems" :key="index">
      <span :class="getClass(item, index)" @click="goto(item)">{{ item.text }}</span>
      <span v-if="visibleItems[index + 1]" class="bdivider">/</span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumb',

  props: [
    'items'
  ],

  computed: {
    visibleItems() {
      return (this.items || []).filter((item) => item && item.text);
    },
  },

  methods: {
    getClass(item, index) {
      if (index + 1 == this.visibleItems.length || item.disabled) return "bdisabled";
      return 'bactive';
    },

    goto(item) {
      if (item.disabled) return;
      this.$router.push({ path: item.href });
    }
  }
}
</script>

<style>
.bactive {
  color: #1c2430;
  font-weight: 600;
  cursor: pointer;
}

.bactive:hover {
  color: var(--primary, #007bff);
}

.cbreadcrumb {
  padding: 16px 0 8px;
  font-size: 0.88rem;
}

.bdivider {
  padding: 0 8px;
  color: #c5cad3;
}

.bdisabled {
  color: #5c6570;
}
</style>
